
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: "page-header",
		props: {
			headerText: String,
		},
	});
